export enum GlobalShortcutBusEvents {
  CreateChannel = 'CreateChannel',
  CreateDM = 'CreateDM',
  AllOrganizations = 'AllOrganizations',
  GoTo = 'GoTo',
  Find = 'Find',
  OpenDocumentation = 'OpenDocumentation',
  Todos = 'Todos',
  MarkAllRead = 'MarkAllRead',
}

export type GlobalShortcutBusEventPayloads = {
  [GlobalShortcutBusEvents.CreateChannel]: void;
  [GlobalShortcutBusEvents.CreateDM]: void;
  [GlobalShortcutBusEvents.AllOrganizations]: void;
  [GlobalShortcutBusEvents.GoTo]: void;
  [GlobalShortcutBusEvents.Find]: void;
  [GlobalShortcutBusEvents.OpenDocumentation]: void;
  [GlobalShortcutBusEvents.Todos]: void;
  [GlobalShortcutBusEvents.MarkAllRead]: void;
};
